// ** React Imports
import { Link } from 'react-router-dom';

// ** Reactstrap Imports
import { Button } from '@febos-io/design';

// ** Custom Hooks
import { useSkin } from '../utility/hooks/useSkin';
import { useDesignContext } from '../../providers';

// ** Styles
import '../core/scss/base/pages/page-misc.scss';
import PropTypes from 'prop-types';
import Error from './Error';

export function NotAuthorized({ children }) {
  // ** Hooks
  const { skin } = useSkin();
  const { AppLogo, appName } = useDesignContext();

  const illustration = skin === 'dark' ? 'not-authorized-dark.svg' : 'not-authorized.svg';
  // eslint-disable-next-line import/no-dynamic-require
  const source = require(`../assets/images/pages/${illustration}`).default;
  return (
    <div className="misc-wrapper">
      <Link
        className="brand-logo"
        to="/"
      >
        <AppLogo />
        <h2 className="brand-text text-primary ms-1">{appName}</h2>
      </Link>
      <div className="misc-inner p-2 p-sm-3">
        <div className="w-100 text-center">
          {children}
          <img
            className="img-fluid"
            src={source}
            alt="Not authorized page"
          />
        </div>
      </div>
    </div>
  );
}

NotAuthorized.propTypes = {
  children: PropTypes.node
};
export default NotAuthorized;
